export default "__VITE_ASSET__CpCAxELJ__"